export default {
  props: {
    name: {
      type: String
    },
    id: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    label: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    }
  }
};
